import {TimelineOptions} from 'vis-timeline/esnext';

const TIMELINE_DEFAULT_OPTIONS: TimelineOptions = {
    align: 'left',
    autoResize: true,
    editable: false,
    selectable: false,
    width: 2000,
    showMajorLabels: false,
    showMinorLabels: true,
    showTooltips: true,
    stack: false,
    format: {
        minorLabels: {
            millisecond: 'SSS',
            second: 's',
            minute: 'HH:mm',
            hour: 'HH:mm',
            weekday: 'ddd D',
            day: 'dddd, DD.MM.YYYY',
            week: '[KW] w (YYYY)',
            month: 'MMMM YYYY',
            year: 'YYYY'
        },
        majorLabels: {
            millisecond: 'HH:mm:ss',
            second: 'D MMMM HH:mm',
            minute: 'ddd D MMMM',
            hour: 'ddd D MMMM',
            weekday: 'MMMM YYYY',
            day: 'MMMM YYYY',
            week: '',
            month: '',
            year: ''
        }
    },
    margin: {
        item: {
            vertical: 16,
        }
    },
    locale: 'de',
    moveable: false,
    orientation: {
        axis: 'top'
    },
};

export {TIMELINE_DEFAULT_OPTIONS};
